import bindAll from 'lodash.bindall';
import debounce from 'lodash.debounce';
import defaultsDeep from 'lodash.defaultsdeep';
import makeToolboxXML from '../lib/make-toolbox-xml';
import whiteListToolboxXML from '../lib/whiteListToolboxXML';
import PropTypes from 'prop-types';
import React from 'react';
import VMScratchBlocks from '../lib/blocks';
import {VM} from '@hetao/scratch-core';

// import analytics from '../lib/analytics';
import log from '../lib/log.js';
import Prompt from './prompt.jsx';
import hetaoStatics from '../lib/hetao-statics.js';
import ConnectionModal from './connection-modal.jsx';
import BlocksComponent from '../components/blocks/blocks.jsx';
import ExtensionLibrary from './extension-library.jsx';
import extensionData from '../lib/libraries/extensions/index.jsx';
import CustomProcedures from './custom-procedures.jsx';
import errorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import {STAGE_DISPLAY_SIZES} from '../lib/layout-constants';
import {isTeacherMode, isStudentMode, isNoMenu, getMode,isAutoJudgementConfig, isFlyoutVisbile} from '../lib/hetao-mode';
import {isMobile} from '../lib/platform';

import {connect} from 'react-redux';
import {updateToolbox} from '../reducers/toolbox';
import {activateColorPicker} from '../reducers/color-picker';
import {closeExtensionLibrary} from '../reducers/modals';
import {activateCustomProcedures, deactivateCustomProcedures} from '../reducers/custom-procedures';
import {ScratchExtensions} from "@hetao/scratch-core";

const {DisguisedBlockly} = ScratchExtensions;
const addFunctionListener = (object, property, callback) => {
    const oldFn = object[property];
    object[property] = function () {
        const result = oldFn.apply(this, arguments);
        callback.apply(this, result);
        return result;
    };
};

class Blocks extends React.Component {
    constructor (props) {
        super(props);
        this.ScratchBlocks = VMScratchBlocks(props.vm);
        if (isStudentMode()) {
            this.ScratchBlocks.setVariableNameIgnoreRegex(new RegExp('^#(.*?)\\*$'));
        }
        bindAll(this, [
            'attachVM',
            'detachVM',
            'handleCategorySelected',
            'handleConnectionModalStart',
            'handleConnectionModalClose',
            'handleStatusButtonUpdate',
            'handlePromptStart',
            'handlePromptCallback',
            'handlePromptClose',
            'handleCustomProceduresClose',
            'onScriptGlowOn',
            'onScriptGlowOff',
            'onBlockGlowOn',
            'onBlockGlowOff',
            'onCostumeNameUpdated',
            'handleExtensionAdded',
            'handleBlocksInfoUpdate',
            'onTargetsUpdate',
            'onVisualReport',
            'onWorkspaceUpdate',
            'onWorkspaceMetricsChange',
            'setBlocks',
            'setLocale',
            'onActivateCustomProcedures',
            'onDeleteProcedureDef',
            'hideSomeBlocksToStudents',
            'onProcedureArgumentDefaultsUpdated',
            'saveArgumentDefaults',
        ]);
        this.ScratchBlocks.prompt = this.handlePromptStart;
        this.ScratchBlocks.statusButtonCallback = this.handleConnectionModalStart;
        this.state = {
            workspaceMetrics: {},
            prompt: null,
            connectionModal: null
        };
        this.onTargetsUpdate = debounce(this.onTargetsUpdate, 100);
        const mode = getMode() === 'TEACHER' ? 'TEACHER' : 'STUDENT';
        this.disguisedBlockly = new DisguisedBlockly({
            vm: this.props.vm,
            Blockly: this.ScratchBlocks,
            mode,
            updateToolboxXMLState: this.props.updateToolboxState
        })
        // TO be used for recomputing xmlToolbox in a situation that
        // reloading project for multi-times without targetId in toolboxXMLString.
        this.xmlStrForDiffer = '';
        this.toolboxUpdateQueue = [];
    }

    componentDidMount () {
        this.ScratchBlocks.FieldColourSlider.activateEyedropper_ = this.props.onActivateColorPicker;
        this.ScratchBlocks.Procedures.externalProcedureDefCallback = this.onActivateCustomProcedures;
        this.ScratchBlocks.Procedures.onDeleteProcedureDef = this.onDeleteProcedureDef;
        const workspaceConfig = defaultsDeep({},
            Blocks.defaultOptions,
            this.props.options,
            {
                endEnv: isTeacherMode() ? 'teacher' : 'student',
                rtl: this.props.isRtl,
                toolbox: this.props.toolboxXML
            }
        );
        if (isNoMenu()) {
            workspaceConfig.zoom.startScale = 0.6;
        }
        this.workspace = this.ScratchBlocks.inject(this.blocks, workspaceConfig);
        window.workspace = this.workspace;
        this.workspace.toolbox_.flyout_.setEnableFlyoutRecycle_(false);
        // we actually never want the workspace to enable "refresh toolbox" - this basically re-renders the
        // entire toolbox every time we reset the workspace.  We call updateToolbox as a part of
        // componentDidUpdate so the toolbox will still correctly be updated
        this.setToolboxRefreshEnabled = this.workspace.setToolboxRefreshEnabled.bind(this.workspace);
        this.workspace.setToolboxRefreshEnabled = () => {
            this.setToolboxRefreshEnabled(false);
        };

        // @todo change this when blockly supports UI events
        addFunctionListener(this.workspace, 'translate', this.onWorkspaceMetricsChange);
        addFunctionListener(this.workspace, 'zoom', this.onWorkspaceMetricsChange);
        this.attachVM();
        // 加载音乐扩展
        if (this.props.isVisible) {
            this.setLocale();
        }
        if (isAutoJudgementConfig()) {
            this.props.vm.runtime.on('PROJECT_LOADED',()=>{
                this.preSelectCatogery('magicblocks');
            });
        }
        if (!isFlyoutVisbile()) {
            this.workspace.toolbox_.flyout_.setVisible(false);
        }
        // analytics.pageview('/editors/blocks');
    }

    shouldComponentUpdate (nextProps, nextState) {
        return (
            this.state.prompt !== nextState.prompt ||
            this.state.connectionModal !== nextState.connectionModal ||
            this.props.isVisible !== nextProps.isVisible ||
            this.props.toolboxXML !== nextProps.toolboxXML ||
            this.props.extensionLibraryVisible !== nextProps.extensionLibraryVisible ||
            this.props.customProceduresVisible !== nextProps.customProceduresVisible ||
            this.props.locale !== nextProps.locale ||
            this.props.anyModalVisible !== nextProps.anyModalVisible ||
            this.props.stageSize !== nextProps.stageSize
        );
    }
    componentDidUpdate (prevProps) {
        // If any modals are open, call hideChaff to close z-indexed field editors
        if (this.props.anyModalVisible && !prevProps.anyModalVisible) {
            this.ScratchBlocks.hideChaff();
        }
        this.disguisedBlockly.setToolboxXML(this.props.toolboxXML)
        if (prevProps.toolboxXML !== this.props.toolboxXML) {
            // rather than update the toolbox "sync" -- update it in the next frame
            clearTimeout(this.toolboxUpdateTimeout);
            this.toolboxUpdateTimeout = setTimeout(() => {
                this.updateToolbox();
            }, 0);
        }
        if (this.props.isVisible === prevProps.isVisible) {
            if (this.props.stageSize !== prevProps.stageSize) {
                // force workspace to redraw for the new stage size
                window.dispatchEvent(new Event('resize'));
            }
            return;
        }
        // @todo hack to resize blockly manually in case resize happened while hidden
        // @todo hack to reload the workspace due to gui bug #413
        if (this.props.isVisible) { // Scripts tab
            this.workspace.setVisible(true);
            if (prevProps.locale !== this.props.locale || this.props.locale !== this.props.vm.getLocale()) {
                // call setLocale if the locale has changed, or changed while the blocks were hidden.
                // vm.getLocale() will be out of sync if locale was changed while not visible
                this.setLocale();
            } else {
                this.props.vm.refreshWorkspace();
                this.updateToolbox();
            }

            window.dispatchEvent(new Event('resize'));
        } else {
            this.workspace.setVisible(false);
        }
    }

    componentWillUnmount () {
        this.detachVM();
        this.workspace.dispose();
        clearTimeout(this.toolboxUpdateTimeout);
    }

    /**
     * @description
     * @param data {Element} mutator a dom descriptor
     * @param callback {Function}
     * @param type {String} create | edit
     */
    onActivateCustomProcedures (data, callback, type) {
        // 如果是创建的话，需要保证proccode不重复，不能使用一个proccode，因为和伪装代码块的逻辑有冲突
        if (type === 'create') {
            const editingTarget = this.props.vm.runtime._editingTarget;
            const nameSchemeRegexp = /\_\d+/;
            let num = 1;
            let oldProccode = data.getAttribute('proccode');
            const hasProccode = (proccode) => {
                const blockids = Object.keys(editingTarget.blocks._blocks);
                for (let i = 0; i < blockids.length; i++) {
                    const block = editingTarget.blocks._blocks[blockids[i]];
                    if (block.mutation && block.mutation.proccode === proccode) {
                        return true
                    }
                }
                return false
            }
            while (hasProccode(oldProccode)) {
                if (nameSchemeRegexp.test(oldProccode)) {
                    oldProccode = oldProccode.replace(nameSchemeRegexp, `_${num}`);
                } else {
                    oldProccode = `${oldProccode}_${num}`;
                }
                num+=1;
            }
            data.setAttribute('proccode', oldProccode)
        }
        this.props.onActivateCustomProcedures(data, callback);
    }

    /**
     * @description 如果定义块已经被用作伪装代码块，需要先解除关联之后才能删除。
     * @param proccode
     * @return {boolean}
     */
    onDeleteProcedureDef (proccode) {
        const disguisedBlockEngine = this.props.vm.disguisedBlockEngine;
        const disguisedBlock = disguisedBlockEngine.findDisguisedBlockByProccode(proccode)
        if (disguisedBlock) {
            alert(`该代码块已被${disguisedBlock.originalOpcode}伪装，请先取消伪装`)
            return false;
        }
    }

    setLocale () {
        this.workspace.getFlyout().setRecyclingEnabled(false);
        this.ScratchBlocks.ScratchMsgs.setLocale(this.props.locale);
        this.props.vm.setLocale(this.props.locale, this.props.messages)
            .then(() => {
                this.props.vm.refreshWorkspace();
                this.updateToolbox();
                this.workspace.getFlyout().setRecyclingEnabled(true);
            });
    }

    updateToolbox () {
        this.toolboxUpdateTimeout = false;
        if (!this.workspace.toolbox_.flyout_.isVisible_ || isMobile()) {
            this.workspace.toolbox_.flyout_.setVisible(true);
            this.workspace.updateToolbox(this.props.toolboxXML);
            this.workspace.toolboxRefreshEnabled_ = true;
            const categorySelectedItem = this.workspace.toolbox_.getSelectedItem();

            if (this.addingExtension){
                this.workspace.toolbox_.setUnFoldedItem(categorySelectedItem);
            } else {
                this.workspace.toolbox_.setFoldedItem(categorySelectedItem);
                this.workspace.toolbox_.flyout_.setVisible(false);
            }
            const queue = this.toolboxUpdateQueue;
            this.toolboxUpdateQueue = [];
            queue.forEach(fn => fn());
            return;
        }

        const categoryId = this.workspace.toolbox_.getSelectedCategoryId();
        const offset = this.workspace.toolbox_.getCategoryScrollOffset();

        this.workspace.updateToolbox(this.props.toolboxXML);

        // In order to catch any changes that mutate the toolbox during "normal runtime"
        // (variable changes/etc), re-enable toolbox refresh.
        // Using the setter function will rerender the entire toolbox which we just rendered.
        this.workspace.toolboxRefreshEnabled_ = true;

        const currentCategoryPos = this.workspace.toolbox_.getCategoryPositionById(categoryId);
        const currentCategoryLen = this.workspace.toolbox_.getCategoryLengthById(categoryId);
        if (offset < currentCategoryLen) {
            this.workspace.toolbox_.setFlyoutScrollPos(currentCategoryPos + offset);
        } else {
            this.workspace.toolbox_.setFlyoutScrollPos(currentCategoryPos);
        }
        const queue = this.toolboxUpdateQueue;
        this.toolboxUpdateQueue = [];
        queue.forEach(fn => fn());
    }

    withToolboxUpdates (fn) {
        // if there is a queued toolbox update, we need to wait
        if (this.toolboxUpdateTimeout) {
            this.toolboxUpdateQueue.push(fn);
        } else {
            fn();
        }
    }
    // 覃京宁 qjn添加 隐藏掉不给学生看到的代码块
    hideSomeBlocksToStudents (){
        // eslint-disable-next-line max-len
        const magicBlocks = this.workspace.getAllBlocks().filter(block => block.type === 'procedures_next_study' || block.type.includes('magicblocks'));
        magicBlocks.forEach(magicBlock => {
            magicBlock.getRootBlock().getSvgRoot().style.display = 'none';
        });
    }
    attachVM () {
        this.workspace.addChangeListener(this.props.vm.blockListener);
        // 埋点
        hetaoStatics(this.workspace);
        this.flyoutWorkspace = this.workspace
            .getFlyout()
            .getWorkspace();
        this.flyoutWorkspace.addChangeListener(this.props.vm.flyoutBlockListener);
        this.flyoutWorkspace.addChangeListener(this.props.vm.monitorBlockListener);
        this.flyoutWorkspace.addChangeListener(this.onProcedureArgumentDefaultsUpdated);

        this.props.vm.addListener('SCRIPT_GLOW_ON', this.onScriptGlowOn);
        this.props.vm.addListener('SCRIPT_GLOW_OFF', this.onScriptGlowOff);
        this.props.vm.addListener('BLOCK_GLOW_ON', this.onBlockGlowOn);
        this.props.vm.addListener('BLOCK_GLOW_OFF', this.onBlockGlowOff);
        this.props.vm.addListener('VISUAL_REPORT', this.onVisualReport);
        this.props.vm.addListener('workspaceUpdate', this.onWorkspaceUpdate);
        this.props.vm.addListener('targetsUpdate', this.onTargetsUpdate);
        this.props.vm.addListener('EXTENSION_ADDED', this.handleExtensionAdded);
        this.props.vm.addListener('BLOCKSINFO_UPDATE', this.handleBlocksInfoUpdate);
        this.props.vm.addListener('PERIPHERAL_CONNECTED', this.handleStatusButtonUpdate);
        this.props.vm.addListener('PERIPHERAL_ERROR', this.handleStatusButtonUpdate);
        this.props.vm.addListener('costumeNameUpdated', this.onCostumeNameUpdated);

    }

    detachVM () {
        this.props.vm.removeListener('SCRIPT_GLOW_ON', this.onScriptGlowOn);
        this.props.vm.removeListener('SCRIPT_GLOW_OFF', this.onScriptGlowOff);
        this.props.vm.removeListener('BLOCK_GLOW_ON', this.onBlockGlowOn);
        this.props.vm.removeListener('BLOCK_GLOW_OFF', this.onBlockGlowOff);
        this.props.vm.removeListener('VISUAL_REPORT', this.onVisualReport);
        this.props.vm.removeListener('workspaceUpdate', this.onWorkspaceUpdate);
        this.props.vm.removeListener('targetsUpdate', this.onTargetsUpdate);
        this.props.vm.removeListener('EXTENSION_ADDED', this.handleExtensionAdded);
        this.props.vm.removeListener('BLOCKSINFO_UPDATE', this.handleBlocksInfoUpdate);
        this.props.vm.removeListener('PERIPHERAL_CONNECTED', this.handleStatusButtonUpdate);
        this.props.vm.removeListener('PERIPHERAL_ERROR', this.handleStatusButtonUpdate);
        this.props.vm.removeListener('costumeNameUpdated', this.onCostumeNameUpdated);

        this.flyoutWorkspace.removeChangeListener(this.props.vm.flyoutBlockListener);
    }

    onCostumeNameUpdated (){
        this.updateToolbox();
        this.props.vm.refreshWorkspace();
    }

    // 更新自定义积木块的默认值
    onProcedureArgumentDefaultsUpdated (event) {
        // 仅教师端有效
        if (getMode() !== 'TEACHER' || event.type !== 'change') {
            return;
        }

        const callerBlock = this.flyoutWorkspace.getBlockById(event.blockId).parentBlock_;
        // 仅处理自定义积木块的默认值
        if (callerBlock?.type !== Blockly.PROCEDURES_CALL_BLOCK_TYPE) {
            return;
        }

        // 当前改变的输入框的 ID
        const changedArgumentId = callerBlock.inputList.find(input => {
            const argumentBlock = input?.connection?.targetBlock();
            return argumentBlock?.id === event.blockId;
        })?.name;

        const prototypeBlock = Blockly.Procedures.getPrototypeBlock(callerBlock.procCode_, this.workspace);
        const argumentIndex = prototypeBlock.argumentIds_.indexOf(changedArgumentId);
        if (argumentIndex === -1) {
            return;
        }

        // 更新当前实例中默认值，防止刷新 Toolbox 时被重置
        const argumentDefaults = prototypeBlock.argumentDefaults_;
        argumentDefaults[argumentIndex] = event.newValue;
        // 持久化自定义积木块的默认值
        this.saveArgumentDefaults(callerBlock.procCode_, argumentDefaults);
    }

    /**
     * 持久化自定义积木块的默认值
     */
    saveArgumentDefaults (procCode, values) {
        const blocks = this.props.vm.runtime.getEditingTarget().blocks._blocks;
        for (const id in blocks) {
            const currentBlock = blocks[id];
            if (currentBlock.opcode !== Blockly.PROCEDURES_PROTOTYPE_BLOCK_TYPE) {
                continue;
            }
            // 修改 vm 中的默认值，会在保存项目时持久化到 sb3 文件中
            if (currentBlock.mutation.proccode === procCode) {
                currentBlock.mutation.argumentdefaults = JSON.stringify(values);
                break;
            }
        }
    }

    updateToolboxBlockValue (id, value) {
        this.withToolboxUpdates(() => {
            const block = this.workspace
                .getFlyout()
                .getWorkspace()
                .getBlockById(id);
            if (block) {
                block.inputList[0].fieldRow[0].setValue(value);
            }
        });
    }

    onTargetsUpdate () {
        if (this.props.vm.editingTarget) {
            ['glide', 'move', 'set'].forEach(prefix => {
                this.updateToolboxBlockValue(`${prefix}x`, Math.round(this.props.vm.editingTarget.x).toString());
                this.updateToolboxBlockValue(`${prefix}y`, Math.round(this.props.vm.editingTarget.y).toString());
            });
        }
    }
    onWorkspaceMetricsChange () {
        const target = this.props.vm.editingTarget;
        if (target && target.id) {
            const workspaceMetrics = Object.assign({}, this.state.workspaceMetrics, {
                [target.id]: {
                    scrollX: this.workspace.scrollX,
                    scrollY: this.workspace.scrollY,
                    scale: this.workspace.scale
                }
            });
            this.setState({workspaceMetrics});
        }
    }

    onScriptGlowOn (data) {
        this.workspace.glowStack(data.id, true);
    }

    onScriptGlowOff (data) {
        this.workspace.glowStack(data.id, false);
    }

    onBlockGlowOn (data) {
        this.workspace.glowBlock(data.id, true);
    }

    onBlockGlowOff (data) {
        this.workspace.glowBlock(data.id, false);
    }

    onVisualReport (data) {
        this.workspace.reportValue(data.id, data.value);
    }

    onWorkspaceUpdate (data) {
        // When we change sprites, update the toolbox to have the new sprite's blocks
        if (this.props.vm.editingTarget) {
            const target = this.props.vm.editingTarget;
            const dynamicBlocksXML = this.props.vm.runtime.getBlocksXML();
            const whiteToolboxXml = this.props.vm.getToolbox();
            const toolboxXML = makeToolboxXML(target.isStage, target.id, dynamicBlocksXML);
            if (whiteToolboxXml.includes('block') && !isTeacherMode()) {
                whiteListToolboxXML(target.isStage, target.id, dynamicBlocksXML, whiteToolboxXml).then(res => {
                    this.xmlStrForDiffer += ' ';
                    this.updateToolboxState(res.xml);
                });
            } else {
                this.updateToolboxState(toolboxXML);
            }
        }

        if (this.props.vm.editingTarget && !this.state.workspaceMetrics[this.props.vm.editingTarget.id]) {
            this.onWorkspaceMetricsChange();
        }

        // Remove and reattach the workspace listener (but allow flyout events)
        this.workspace.removeChangeListener(this.props.vm.blockListener);
        const dom = this.ScratchBlocks.Xml.textToDom(data.xml);
        try {
            this.ScratchBlocks.Xml.clearWorkspaceAndLoadFromXml(dom, this.workspace);
        } catch (error) {
            // The workspace is likely incomplete. What did update should be
            // functional.
            //
            // Instead of throwing the error, by logging it and continuing as
            // normal lets the other workspace update processes complete in the
            // gui and vm, which lets the vm run even if the workspace is
            // incomplete. Throwing the error would keep things like setting the
            // correct editing target from happening which can interfere with
            // some blocks and processes in the vm.
            error.message = `Workspace Update Error: ${error.message}`;
            log.error(error);
        }
        this.workspace.addChangeListener(this.props.vm.blockListener);

        if (this.props.vm.editingTarget && this.state.workspaceMetrics[this.props.vm.editingTarget.id]) {
            const {scrollX, scrollY, scale} = this.state.workspaceMetrics[this.props.vm.editingTarget.id];
            this.workspace.scrollX = scrollX;
            this.workspace.scrollY = scrollY;
            this.workspace.scale = scale;
            this.workspace.resize();
        }
        // Clear the undo state of the workspace since this is a
        // fresh workspace and we don't want any changes made to another sprites
        // workspace to be 'undone' here.
        this.workspace.clearUndo();
        // 如果，不是老师模式把含有“进入下一课“的代码块及其及跟他有联系的代码块隐藏掉
        if (!isTeacherMode()) {
            this.hideSomeBlocksToStudents();
        }
    }

    handleExtensionAdded (blocksInfo) {
        // select JSON from each block info object then reject the pseudo-blocks which don't have JSON, like separators
        // this actually defines blocks and MUST run regardless of the UI state
        this.ScratchBlocks.defineBlocksWithJsonArray(blocksInfo.map(blockInfo => blockInfo.json).filter(x => x));

        // autoClose is true on iPad
        this.workspace.toolbox_.flyout_ && this.workspace.toolbox_.flyout_.autoClose && (this.workspace.toolbox_.flyout_.isVisible_ = false); // eslint-disable-line max-len

        // update the toolbox view: this can be skipped if we're not looking at a target, etc.
        const runtime = this.props.vm.runtime;
        const target = runtime.getEditingTarget() || runtime.getTargetForStage();
        const dynamicBlocksXML = runtime.getBlocksXML();
        if (target) {
            const toolboxXML = makeToolboxXML(target.isStage, target.id, dynamicBlocksXML);
            const whiteToolboxXml = this.props.vm.getToolbox();
            if (whiteToolboxXml.includes('block') && !isTeacherMode()) {
                whiteListToolboxXML(target.isStage, target.id, dynamicBlocksXML, whiteToolboxXml).then(res => {
                    this.updateToolboxState(res.xml);
                });
            } else {
                this.updateToolboxState(toolboxXML);
            }
        }
    }
    preSelectCatogery(catId) {
        if (this.props.vm.extensionManager.isExtensionLoaded(catId)) {
            this.handleCategorySelected(catId);
        } else {
            this.props.vm.extensionManager.loadExtensionURL(catId).then(() => {
                this.handleCategorySelected(catId);
            });
        }
    }
    updateToolboxState (curXML) {
        let newXML = curXML;
        if (!isTeacherMode()) {
            // 如果不是教师模式把业务需要的代码块隐藏掉，暂时只对新增的通过扩展添加的blocks有效
            const xmlDom = Blockly.Xml.textToDom(newXML);
            const magicXmlDom = xmlDom.querySelector('#magicblocks');
            if (magicXmlDom) {
                magicXmlDom.parentNode.removeChild(magicXmlDom);
                newXML = Blockly.Xml.domToText(xmlDom);
            }
        }
        this.disguisedBlockly.setToolboxXML(newXML);
        const toolboxXML = this.disguisedBlockly.getUpdatedDisguisedToolbox();
        this.props.updateToolboxState(toolboxXML + this.xmlStrForDiffer);
    }

    handleBlocksInfoUpdate (blocksInfo) {
        // @todo Later we should replace this to avoid all the warnings from redefining blocks.
        this.handleExtensionAdded(blocksInfo);
    }
    handleCategorySelected (categoryId) {
        const categoryIds = this.workspace.toolbox_.flyout_.categoryScrollPositions;
        for (let i = 0; i < categoryIds.length; i++) {
            if (categoryId === categoryIds[i].categoryId) {
                return;
            }
        }
        const extension = extensionData.find(ext => ext.extensionId === categoryId);
        if (extension && extension.launchPeripheralConnectionFlow) {
            this.handleConnectionModalStart(categoryId);
        }
        this.addingExtension = true;
        this.withToolboxUpdates(() => {
            this.workspace.toolbox_.setSelectedCategoryById(categoryId);
            this.addingExtension = false;
        });
    }
    setBlocks (blocks) {
        this.blocks = blocks;
    }
    handlePromptStart (message, defaultValue, callback, optTitle, optVarType) {
        const p = {prompt: {callback, message, defaultValue}};
        p.prompt.title = optTitle ? optTitle :
            this.ScratchBlocks.Msg.VARIABLE_MODAL_TITLE;
        p.prompt.varType = typeof optVarType === 'string' ?
            optVarType : this.ScratchBlocks.SCALAR_VARIABLE_TYPE;
        p.prompt.showMoreOptions =
            optVarType !== this.ScratchBlocks.BROADCAST_MESSAGE_VARIABLE_TYPE &&
            p.prompt.title !== this.ScratchBlocks.Msg.RENAME_VARIABLE_MODAL_TITLE &&
            p.prompt.title !== this.ScratchBlocks.Msg.RENAME_LIST_MODAL_TITLE;
        this.setState(p);
    }
    handleConnectionModalStart (extensionId) {
        const extension = extensionData.find(ext => ext.extensionId === extensionId);
        if (extension) {
            this.setState({connectionModal: {
                extensionId: extensionId,
                useAutoScan: extension.useAutoScan,
                peripheralImage: extension.peripheralImage,
                smallPeripheralImage: extension.smallPeripheralImage,
                peripheralButtonImage: extension.peripheralButtonImage,
                name: extension.name,
                connectingMessage: extension.connectingMessage,
                helpLink: extension.helpLink
            }});
        }
    }
    handleConnectionModalClose () {
        this.setState({connectionModal: null});
    }
    handleStatusButtonUpdate () {
        this.ScratchBlocks.refreshStatusButtons(this.workspace);
    }
    handlePromptCallback (input, optionSelection) {
        this.state.prompt.callback(
            input,
            this.props.vm.runtime.getAllVarNamesOfType(this.state.prompt.varType),
            optionSelection);
        this.handlePromptClose();
    }
    handlePromptClose () {
        this.setState({prompt: null});
    }
    handleCustomProceduresClose (data) {
        // debugger;
        this.props.onRequestCloseCustomProcedures(data);
        const ws = this.workspace;
        ws.refreshToolboxSelection_();

        if (data) {
            // 滚动到对应的类别
            let categoryId = data.getAttribute('category') || 'myBlocks';
            if (categoryId === Blockly.Categories.sound) {
                categoryId = "sound";
            }
            ws.toolbox_.selectCategoryById(categoryId);
            ws.toolbox_.scrollToCategoryById(categoryId);
        }
    }
    render () {
        /* eslint-disable no-unused-vars */
        const {
            anyModalVisible,
            customProceduresVisible,
            extensionLibraryVisible,
            options,
            stageSize,
            vm,
            isRtl,
            isVisible,
            onActivateColorPicker,
            updateToolboxState,
            onActivateCustomProcedures,
            onRequestCloseExtensionLibrary,
            onRequestCloseCustomProcedures,
            toolboxXML,
            ...props
        } = this.props;
        /* eslint-enable no-unused-vars */
        return (
            <div>
                <BlocksComponent
                    componentRef={this.setBlocks}
                    {...props}
                />
                {this.state.prompt ? (
                    <Prompt
                        isStage={vm.runtime.getEditingTarget().isStage}
                        label={this.state.prompt.message}
                        placeholder={this.state.prompt.defaultValue}
                        showMoreOptions={this.state.prompt.showMoreOptions}
                        title={this.state.prompt.title}
                        onCancel={this.handlePromptClose}
                        onOk={this.handlePromptCallback}
                    />
                ) : null}
                {this.state.connectionModal ? (
                    <ConnectionModal
                        {...this.state.connectionModal}
                        vm={vm}
                        onCancel={this.handleConnectionModalClose}
                        onStatusButtonUpdate={this.handleStatusButtonUpdate}
                    />
                ) : null}
                {extensionLibraryVisible ? (
                    <ExtensionLibrary
                        toolboxXML={this.props.vm.getToolbox()}
                        vm={vm}
                        onCategorySelected={this.handleCategorySelected}
                        onRequestClose={onRequestCloseExtensionLibrary}
                    />
                ) : null}
                {customProceduresVisible ? (
                    <CustomProcedures
                        options={{
                            media: options.media
                        }}
                        vm={vm}
                        workspace={this.ws}
                        scratchBlocks={this.ScratchBlocks}
                        onRequestClose={this.handleCustomProceduresClose}
                    />
                ) : null}

            </div>
        );
    }
}

Blocks.propTypes = {
    anyModalVisible: PropTypes.bool,
    customProceduresVisible: PropTypes.bool,
    extensionLibraryVisible: PropTypes.bool,
    isRtl: PropTypes.bool,
    isVisible: PropTypes.bool,
    locale: PropTypes.string,
    messages: PropTypes.objectOf(PropTypes.string),
    onActivateColorPicker: PropTypes.func,
    onActivateCustomProcedures: PropTypes.func,
    onRequestCloseCustomProcedures: PropTypes.func,
    onRequestCloseExtensionLibrary: PropTypes.func,
    options: PropTypes.shape({
        media: PropTypes.string,
        zoom: PropTypes.shape({
            controls: PropTypes.bool,
            wheel: PropTypes.bool,
            startScale: PropTypes.number
        }),
        colours: PropTypes.shape({
            workspace: PropTypes.string,
            flyout: PropTypes.string,
            toolbox: PropTypes.string,
            toolboxSelected: PropTypes.string,
            scrollbar: PropTypes.string,
            scrollbarHover: PropTypes.string,
            insertionMarker: PropTypes.string,
            insertionMarkerOpacity: PropTypes.number,
            fieldShadow: PropTypes.string,
            dragShadowOpacity: PropTypes.number
        }),
        comments: PropTypes.bool,
        collapse: PropTypes.bool
    }),
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    toolboxXML: PropTypes.string,
    updateToolboxState: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

Blocks.defaultOptions = {
    zoom: {
        controls: true,
        wheel: true,
        startScale: 0.75
    },
    grid: {
        spacing: 40,
        length: 2,
        colour: '#ddd'
    },
    colours: {
        workspace: '#FFFFFF',
        flyout: '#F9F9F9',
        toolbox: '#FFFFFF',
        toolboxSelected: '#F9F9F9',
        toolboxText: '#696D6F',
        scrollbar: '#DDDDDD',
        scrollbarHover: '#DDDDDD',
        insertionMarker: '#000000',
        insertionMarkerOpacity: 0.2,
        fieldShadow: 'rgba(255, 255, 255, 0.3)',
        dragShadowOpacity: 0.6,
        event: {
            primary: '#E1BA3F',
            secondary: '#E1BA3F',
            tertiary: '#CC9900'
        }
    },
    comments: true,
    collapse: false,
    sounds: false
};

Blocks.defaultProps = {
    isVisible: true,
    options: Blocks.defaultOptions
};

const mapStateToProps = state => ({
    anyModalVisible: (
        Object.keys(state.scratchGui.modals).some(key => state.scratchGui.modals[key]) ||
        state.scratchGui.mode.isFullScreen
    ),
    extensionLibraryVisible: state.scratchGui.modals.extensionLibrary,
    isRtl: state.locales.isRtl,
    locale: state.locales.locale,
    messages: state.locales.messages,
    toolboxXML: state.scratchGui.toolbox.toolboxXML,
    customProceduresVisible: state.scratchGui.customProcedures.active
});

const mapDispatchToProps = dispatch => ({
    onActivateColorPicker: callback => dispatch(activateColorPicker(callback)),
    onActivateCustomProcedures: (data, callback) => {
        dispatch(activateCustomProcedures(data, callback));
    },
    onRequestCloseExtensionLibrary: () => {
        dispatch(closeExtensionLibrary());
    },
    onRequestCloseCustomProcedures: data => {
        dispatch(deactivateCustomProcedures(data));
    },
    updateToolboxState: (toolboxXML) => {
        // 添加disguisedBlocks 到对应位置的 toolboxXML中
        dispatch(updateToolbox(toolboxXML));
    }
});

export default errorBoundaryHOC('Blocks')(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Blocks)
);
